import { useRegisterSW } from "virtual:pwa-register/react";

import { logOnDev } from "@/services/axios/interceptors/response";

export const useServiceWorker = () => {
  const { offlineReady, needRefresh, updateServiceWorker } = useRegisterSW({
    onRegisteredSW(swUrl, r) {
      logOnDev(`Service Worker at: ${swUrl}`);
      logOnDev("SW Registered:", r);
    },
    onRegisterError(error) {
      logOnDev("SW registration error", error);
    },
  });

  return { offlineReady, needRefresh, updateServiceWorker };
};
